<template>
    <ul v-if="filteredItems.admin[0]">
        <router-link
            v-if="!isNull(filteredItems.admin[0].codigounicotela)"
            :to="{ name: filteredItems.admin[0].codigounicotela }"
            class="menu-item"
            tag="li"
        >
            <svg class="svg-icons" v-if="!filteredItems.admin[0].iconeexterno">
                <use
                    :xlink:href="
                        require(`@/assets/img/icons/${filteredItems.admin[0].icone}.svg`) + '#layer'
                    "
                ></use>
            </svg>
            <b-icon
                v-else-if="filteredItems.admin[0].iconeexterno"
                class="menu-wrapper"
                custom-class="menu-icon-sidebar"
                :icon="filteredItems.admin[0].icone"
            />
            <div :class="tagnew(filteredItems.admin[0].tagnew)">
                {{ $t(filteredItems.admin[0].nome) }}
            </div>
        </router-link>

        <li v-else class="menu-item" @click="menuItemHandler(filteredItems.admin[0])">
            <svg class="svg-icons" v-if="!filteredItems.admin[0].iconeexterno">
                <use
                    :xlink:href="
                        require(`@/assets/img/icons/${filteredItems.admin[0].icone}.svg`) + '#layer'
                    "
                ></use>
            </svg>
            <b-icon
                v-else-if="filteredItems.admin[0].iconeexterno"
                class="menu-wrapper"
                custom-class="menu-icon-sidebar"
                :icon="filteredItems.admin[0].icone"
            />
            <div :class="tagnew(filteredItems.admin[0].tagnew)">
                {{ $t(filteredItems.admin[0].nome) }}
            </div>

            <ul
                v-if="filteredItems.admin[0].app_tela && filteredItems.admin[0].app_tela.length > 0"
                class="submenu-items"
                :class="{ 'show-submenu': filteredItems.admin[0].expanded }"
                @click.stop
            >
                <router-link
                    class="submenu-item"
                    v-for="sub in getItensPermitidos(filteredItems.admin[0].app_tela)"
                    :key="sub.codigounicotela"
                    :to="{ name: sub.codigounicotela }"
                    @click.native="subItemHandler"
                >
                    <li :class="tagnew(sub.tagnew)">
                        {{ $t(sub.nome) }}
                    </li>
                </router-link>
            </ul>
        </li>
    </ul>
</template>

<script>
import MenuConfig from '@/functions/Menu.js';

export default {
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
        busca: {
            type: String,
            default: '',
        },
    },
    watch: {
        busca(val) {
            this.onSearch(val);
        },
    },
    data() {
        return {
            items: [],
            filteredItems: [],
            modulos: [],
            debouncedOnSearch: null,
            cleanOnChangeModule: false,
        };
    },
    created() {
        this.sidebarItems = new MenuConfig();

        this.items = this.loadSidebar(this.data);
        this.filteredItems = JSON.parse(JSON.stringify(this.items));

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.onSearch('');

        if (this.$store.state.modulopda.disponivel) {
            this.modulos = this.$store.state.modulopda.data.map((e) =>
                e.descricao.toLocaleUpperCase()
            );
        }
    },
    mounted() {
        setTimeout(() => {
            this.setActived();
        }, 1000);
    },
    methods: {
        loadSidebar(perfil) {
            let items = {};
            if (perfil && perfil.app_moduloList) {
                perfil.app_moduloList.forEach((app_modulo) => {
                    let app_modulo_inner = [];
                    if (app_modulo.nome == 'admin') {
                        app_modulo.app_moduloList.forEach((app_modulo2) => {
                            let app_tela_inner = [];
                            if (app_modulo2.nome == 'integracao') {
                                // Se a tela estiver configurada para ser exibida e o
                                // usuário tiver permissão de leitura, mostra a tela na sidebar
                                app_tela_inner = app_modulo2.app_telaList.filter((app_tela) => {
                                    return (
                                        (perfil.admin && app_tela.visivel) ||
                                        (!perfil.admin &&
                                            app_tela.visivel &&
                                            app_tela.perm_perfilacessotelas &&
                                            app_tela.perm_perfilacessotelas.read)
                                    );
                                });
                            }
                            app_modulo2.expanded = false;
                            app_modulo2.app_tela = app_tela_inner;
                            // Caso o modulo tenha qualquer item, inclui o módulo na sidebar.
                            if (app_modulo2.app_tela.length > 0) {
                                app_modulo_inner.push(app_modulo2);
                            }
                        });
                    }
                    items[app_modulo.nome] = app_modulo_inner;
                });
            }

            return items;
        },
        onSearch(value) {
            let contextoAtual = 'admin';

            if (value && value.trim() != '') {
                // ALTERAR FILTERS, TENTAR USAR PUSH NUM ARRAY NOVO QUE PODE PERDER REFERENCIA
                this.filteredItems[contextoAtual] = [];
                this.items[contextoAtual].forEach((item) => {
                    let obj = JSON.parse(JSON.stringify(item));
                    let tempArrayOfItems = [];

                    if (item.app_tela != null) {
                        item.app_tela.forEach((tela) => {
                            let x = this.$t(tela.nome);
                            if (x.toLowerCase().includes(value.toLowerCase())) {
                                tempArrayOfItems.push({ ...tela });
                            }
                        });
                    }

                    obj.app_tela = tempArrayOfItems;
                    if (tempArrayOfItems.length > 0) {
                        this.filteredItems[contextoAtual].push(obj);
                    }
                });
            } else {
                this.filteredItems[contextoAtual] = JSON.parse(
                    JSON.stringify(this.items[contextoAtual])
                );
            }
            if (value != '') this.searchExpandIntegracao();
        },
        searchExpandIntegracao() {
            for (let key in this.filteredItems) {
                this.filteredItems[key].filter((z) => {
                    z.expanded = true;
                });
            }
        },
        menuItemHandler(item) {
            if (item.clickfn && typeof this[item.clickfn] === 'function') {
                /* A função tem que retornar true/false se permitir expandir o sub-item ou não */
                if (this[item.clickfn]()) {
                    item.expanded = !item.expanded;
                }
            } else {
                item.expanded = !item.expanded;
            }
        },
        getItensPermitidos(items) {
            /* Filtrar os itens que não tem permissão via MODULOPDA */
            return items.filter((sub) => {
                if (sub.admin === true) {
                    return this.$store.state.user.admin == sub.admin;
                }

                /* Se não houver especificação de moduloPDA, permitir aparecer. */
                if (sub.modulopda == undefined) {
                    return true;

                    /* Se houver, verificar */
                } else {
                    return (
                        this.moduloDisponivel(sub.modulopda) &&
                        this.moduloPermiteInlcuir(sub.modulopda)
                    );
                }
            });
        },
        subItemHandler() {
            /* $parent = Header.vue */
            if (this.$parent.bigScreen === false) {
                /* Se o sidebar estiver no modo mobile, vai esconder ao clicar em um item */
                this.$parent.showBar = false;
            }
        },
        promptGeo() {
            let admin = this.$store.state.user.admin;

            if (!this.$store.state.user.gmapsApiKey && admin) {
                /* Admin: Mostra a opção de ir na config pra inserir a chave. */
                this.$root.confirm({
                    message: this.$t('msg-geoanalise-no-keys-admin'),
                    onConfirm: this.redirectConfigMapa,
                });
                return false;
            } else if (!this.$store.state.user.gmapsApiKey && !admin) {
                /* User. Somente mostra o aviso pois ele não tem permissão da chave. */
                this.$root.alert({
                    message: this.$t('msg-geoanalise-no-keys-user'),
                });
                return false;
            } else {
                return true;
            }
        },
        redirectConfigMapa() {
            this.$router.push({ name: 'configuracao-mapas' });
        },
        setActived() {
            let contextoAtual = 'admin';
            let caminhoAtual = this.$route.path;

            this.items[contextoAtual].forEach((item) => {
                if (item.expanded != undefined && caminhoAtual.includes(item.nome)) {
                    item.expanded = true;
                }
            });
        },
        redirectToContext(context) {
            let target = context + '-cockpit';
            console.log(`Redirecionando para o contexto ${this.$store.getters.contexto}`);
            this.$router.push({ name: target });

            this.cleanOnChangeModule = true;
            this.onSearch('');
            setTimeout(() => {
                this.cleanOnChangeModule = false;
            }, 300);
        },
        moduloDisponivel(descricao) {
            return this.modulos.includes(descricao.toLocaleUpperCase());
        },
        moduloPermiteInlcuir(descricao) {
            let canAppear = false;
            this.$store.state.modulopda.data.some((mod) => {
                if (mod.descricao == descricao.toLocaleUpperCase()) {
                    canAppear = mod.inclui == 1;
                    return canAppear;
                }
            });
            return canAppear;
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin hiddenSubMenu($percent) {
    opacity: 0 !important;
    margin-bottom: $percent !important;
}

@mixin transitionSubMenu($duration) {
    transition-timing-function: ease-in;
    transition: opacity $duration, margin $duration;
}

.sb {
    background-color: $sovis-white;
    color: $light-gray-color;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
    }

    &::-webkit-scrollbar-track {
        background: $darker-bg-color;
        border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb {
        background: $sb-background;
        border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: $light-gray-color;
    }
}

ul {
    list-style: none;
}

.bottom-menu {
    width: 100%;
    height: auto;
    flex: 0 0 auto;
}

.bottom-menu .menu-item-detached {
    padding-left: 40px;
    padding-bottom: 10px;
    > a {
        color: $darker-gray-color;
        font-weight: 600;
        font-size: 14px;
        margin-top: 10px;
        text-decoration: none;
    }
    &:nth-child(2) {
        border-top: 1px solid $table-border;
        border-bottom: 1px solid $table-border;
    }
}
.bottom-menu p {
    text-align: center;
    //  padding-left: 60px;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 15px;
    color: $light-gray-color;
}
.menu-items {
    padding: 0;
    flex: 1 1 auto;
}
.menu-item {
    position: relative;
    cursor: pointer;
    transition: color 0.2s;
    background: $sovis-white;
    z-index: 10;
    padding: 0 0 9px 40px;
    display: flex;
    flex-wrap: wrap;

    > .svg-icons,
    > .menu-wrapper {
        fill: $darker-gray-color;
        width: 14px;
        height: 14px;
        margin-left: -9px;
        margin-right: 11px;
        margin-top: 14px;
    }

    > .menu-wrapper {
        width: 12px;
        height: 12px;
    }

    > span {
        margin-left: -10px;
        margin-right: 15px;
    }

    > div {
        color: $darker-gray-color;
        font-size: 14px;
        text-decoration: none;
        font-weight: 600;
        margin-top: 11px;
    }

    &:hover {
        background-color: $bg-color;
    }

    &:hover .svg-icons {
        fill: $primary-color;
        background-color: $bg-color;
    }
    &:hover .menu-wrapper {
        color: $primary-color;
        background-color: $bg-color;
    }

    &:before {
        width: 35px;
    }

    &.active,
    &.active .svg-icons {
        background-color: $bg-color;
        fill: $primary-color;
    }

    &.active .menu-wrapper {
        color: $primary-color;
        background-color: $bg-color;
    }

    .block-menu {
        width: 100%;
        height: 100%;
    }
}

.menu-item.active::before,
.menu-item:hover::before {
    content: '|';
    border-left: 5px solid $primary-color;
    margin-left: -40px;
    margin-right: 35px;
    font-size: 26px;
    line-height: 44px;
    color: $bg-color;
    position: absolute;
}

.menu {
    width: 100%;
    text-align: center;
    font-weight: 600;
    padding: 26px 5px 16px 5px;
    font-size: 12px;
}

.submenu-items {
    left: -40px;
    position: relative;
    top: 10px;
    width: 100%;
    background: $sovis-white;
    flex: 0 0 100%;
    padding-left: 40px;
    box-sizing: content-box;
    overflow: hidden;
    opacity: 0;
    max-height: 0;
    transition: max-height 0.5s, opacity 1s;
}

.show-submenu {
    opacity: 1;
    max-height: 2000px;
}

.submenu-item {
    li {
        position: relative;
        font-size: 12px;
        margin-bottom: 5px;
        transition: color 0.2s;
        padding: 10px 5px 10px 0;
        z-index: 5;
        margin-left: 40px;
        cursor: pointer;
        color: $darker-gray-color;
        text-decoration: none;
        font-weight: 600;
    }

    > span {
        margin-left: -10px;
        margin-right: 15px;
    }

    &:hover {
        color: $primary-color;
        list-style-type: disc;
    }

    &:before {
        width: 35px;
    }

    &.active {
        list-style-type: disc;
        color: $primary-color;
    }

    .block-menu {
        width: 100%;
        height: 100%;
    }

    &:first-child {
        margin-top: 10px;
    }
}
.licences {
    text-decoration: none;
    color: $light-gray-color;
}

.pro-enter-active,
.pro-leave-active,
.geo-enter-active,
.geo-leave-active,
.produto-enter-active,
.produto-leave-active,
.bs-data-enter-active,
.bs-data-leave-active,
.integracao-enter-active,
.integracao-leave-active,
.reports-enter-active,
.reports-leave-active {
    @include transitionSubMenu(0.5s);
}

.pro-enter,
.pro-leave-to,
.geo-enter,
.geo-leave-to,
.produto-enter,
.produto-leave-to,
.bs-data-enter,
.bs-data-leave-to,
.integracao-enter,
.integracao-leave-to,
.reports-enter,
.reports-leave-to {
    @include hiddenSubMenu(-245px);
}

.contexto-button {
    width: 100%;
    background: $primary-color;
    color: $sovis-white;
    border: 0;
    border-radius: 0;
    padding-top: 7px;
    justify-content: space-between;

    &:hover,
    &:focus {
        border: 0;
        color: $sovis-white;

        &:not(:active) {
            box-shadow: none;
        }
    }
}

@media only screen and (max-width: 760px) {
    .menu {
        display: none;
    }
}

@media only screen and (max-height: 850px) {
    .bottom-menu {
        width: 100%;
        height: 80px;
    }
}
</style>
